<template>
  <!-- Backdrop -->
  <transition
    enter-active-class="transition duration-200 ease-out"
    leave-active-class="transition duration-200 ease-out"
    enter-from-class="opacity-0"
    enter-to-class="opacity-100"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div
      v-if="isOpen"
      class="fixed inset-0 z-10 bg-neutral-700/50"
    />
  </transition>

  <!-- Modal -->
  <transition
    enter-active-class="transition duration-200 ease-out"
    leave-active-class="transition duration-200 ease-out"
    enter-from-class="opacity-0 translate-y-10"
    enter-to-class="opacity-100 translate-y-0"
    leave-from-class="opacity-100 translate-y-0"
    leave-to-class="opacity-0 translate-y-10"
  >
    <SfModal
      ref="currentModal"
      :model-value="isOpen"
      :cross="true"
      aria-haspopup="dialog"
      class="z-10 max-h-full overflow-auto lg:!p-8 mobile:h-auto mobile:w-full mobile:overflow-auto mobile:rounded-none"
      @close="emit('close')"
    >
      <header>
        <SfButton
          square
          variant="tertiary"
          class="absolute right-2 top-2"
          :data-testid="`${id}__close-button`"
          :aria-label="$t('Close')"
          @click="emit('close')"
        >
          <SfIconClose />
        </SfButton>
      </header>
      <slot name="content" />
    </SfModal>
  </transition>
</template>

<script lang="ts" setup>
import {
  SfButton,
  SfModal,
  SfIconClose,
} from '@storefront-ui/vue';
import { onClickOutside } from '@vueuse/core';

interface Props {
  id?: string;
  isOpen?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  id: 'modal',
  isOpen: false,
});

const emit = defineEmits(['close']);

const currentModal = ref();

onClickOutside(currentModal, () => {
  if (props.isOpen) {
    emit('close');
  }
});
</script>
